import React from "react";
import "../../dashboard/pages/index.css";

interface BackdropParams {
  showSidePanel?: boolean;
  setShowSidePanel?: (show: boolean) => void;
}

const Backdrop = ({ showSidePanel, setShowSidePanel }: BackdropParams) => {
  return (
    <div
      style={{
        display: showSidePanel ? "block" : "none",
      }}
      onClick={() => setShowSidePanel(false)}
      className="backdrop"
    ></div>
  );
};

export default Backdrop;
